<template>
    <div class="picture-modal-mask" @click="cancel" @touchmove.prevent>
        <div class="picture-modal-dialog" @click="e => e.stopPropagation()">
            <div class="picture-modal-body">
                <div class="picture-modal-close">
                    <i class="el-icon-close" @click="cancel">关闭</i>
                </div>
                <img class="picture-modal-image" :src="imageUrl" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.picture-modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 3010;
    @include flex-center;
}

.picture-modal-dialog {
    max-width: 90vw;
    max-height: 90vh;
    flex-shrink: 0;
    flex-grow: 0;
    border-radius: 10px;
    background-color: #ffffff;
    z-index: 3001;
}

.picture-modal-body {
    padding: 5px 15px 15px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.picture-modal-close {
    width: 100%;
    text-align: right;
    right: 0;
    font-size: 12px;
    color: #666666;
    cursor: pointer;
    padding-bottom: 5px;
}

.picture-modal-image {
    min-width: 30px;
    min-height: 30px;
    max-width: calc(90vw - 30px);
    max-height: calc(90vh - 42px);
}
</style>

<script>
export default {
    props: {
        imageUrl: String
    },
    methods: {
        cancel() {
            this.remove()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/info/ImageModal.vue